











import Vue from 'vue';
import Component from 'vue-class-component';
import 'vuetify/dist/vuetify.min.css'
import VueMatomo from "vue-matomo";
import ToolBar from "@/components/ToolBar.vue";

import {ImageApi, ImageCollectionDto} from "@swagger";
import BasicComponent from "@/global/BasicComponent";
import Footer from "@/components/Footer.vue";
import {Watch} from "vue-property-decorator";
import HelpBubble from "@/components/HelpBubble.vue";
import {loadStripe} from "@stripe/stripe-js";

@Component({
  components: {HelpBubble, Footer, ToolBar}
})
export default class App extends BasicComponent {

  created() {
    try {
      this.registerAnalytics();
    } catch (e) {
      console.error("Error while registering analytics", e);
    }
    if (this.stepSet) {
      this.setStep(this.$route.query.step, true, false);
    } else {
      this.setStep(1, false, false);
    }

    new ImageApi(this.apiConfiguration).getImages()
        .then((data: ImageCollectionDto) => {
          this.$store.commit("setImageSelection", data);
          if (this.mayAutoSwitchStep()) {
            if (data.images.length > 0) {
              if (! this.stepSet) {
                this.setStep(3);
              }
            } else {
              this.setStep(1);
            }
          }
        })
        .catch((err) => {
          err.json().then(error => {
            console.error(error.message);
            this.setStep(1); // Return to code insertion
            //this.errorMessage = error.message;
          });
        });

    this.requestProducts();
    this.getBasketData();
    this.requestCoupons();

    this.onRouteChange(this.$route, null);

    this.loadStripe();
  }

  registerAnalytics() {
    const router = this.$router;

    Vue.use(VueMatomo, {
      siteId: 3,
      host: "https://analytics.gngn.at",
      disableCookies: true,
    });
    /*
    Vue.use(VueAnalytics, {
      id: this.$t("gaId").toString(),
      router,
      set: [
        {field: 'anonymizeIp', value: true}
      ],
      autoTracking: {
        pageviewOnLoad: false,
        page: false
      },
      debug: {
        enabled: false, // default value
        trace: false, // default value
        sendHitTask: true // default value
      }
    });
    this.track();
     */
  }

  track() {
    //this["$ga"].screenview("home");
  }

  shouldRerender() { // Step 2 should always be rerendered
    const should = this.$route.path === "/" && String(this.$route.query.step) === "2";
    return should + "";
  }

  /**
   * Whether to automatically navigate to the latest available step or stay at the current step
   */
  mayAutoSwitchStep(): boolean {
    if (Number(this.$route.query.step) === 1) return false;
    return true;
  }

  loadStripe() {
    loadStripe(this.$t("stripePublicKey").toString())
        .then((stripe) => {
          this.$store.commit("setStripe", stripe);
        })
        .catch((err) => {
          console.error("Error while loading stripe", err);
        });
  }

  @Watch("$route")
  onRouteChange(to, from) {
    window.scrollTo(0, 0);
  }

}

function getHost() {
  return window.location.host;
}


document.addEventListener("touchstart", function () {
}, true);

